import axios from "axios";

const fetchApi = axios.create({
  baseURL: `${document.getElementById("root").baseURI}api/`,
});

export default fetchApi;
